import gql from 'graphql-tag';

import {PricingGroup} from '../settings/pricing-groups/pricing-group.fragment';

export const FetchPricingGroups = gql`
    query FetchPricingGroups(
        $institutionSetIds: [InstitutionSetId!]
        $institutionSetId: InstitutionSetId!
        $pricingGroupIds: [PricingGroupId!]
        $includeDeleted: Boolean
    ) {
        finance {
            pricingGroups {
                behaviors(institutionSetId: $institutionSetId) {
                    behaviorId
                }
                list(
                    institutionSetIds: $institutionSetIds
                    pricingGroupIds: $pricingGroupIds
                    includeDeleted: $includeDeleted
                ) {
                    ...PricingGroup
                }
            }
            oldPricingGroups: pricingGroups {
                list(pricingGroupIds: $pricingGroupIds) {
                    ...PricingGroup
                }
            }
        }
    }

    ${PricingGroup}
`;
